import { Navbar, Nav, Dropdown } from 'rsuite'
import styles from './header.module.scss'
import cn from 'classnames'

export const CustomNavbar = props => <Navbar className={styles.navbar} {...props} />

export const CustomNavHeader = props => <Navbar.Brand className={styles.navBarHeader} {...props} />

export const CustomNavIcoItem = props => <Nav.Item className={styles.navIcon} {...props} />

export const CustomDropdown = ({ className, ...props }) => (
  <Dropdown className={cn(styles.navDropdown, className)} {...props} />
)

export const LanguageDropdown = props => <CustomDropdown className={styles.navDropdownLanguage} {...props} />
